module.exports = __webpack_public_path__ + "img/7.dde36b10.png";